export default __webpack_public_path__ + "static/hw_ff_ultra-divider-6d61f84710362eacf369e0098c53701f.png";